import React, { useState, useEffect } from 'react';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Logo from '../../Asset/images/logo-blaxk.webp';
import { useNavigate, useLocation } from 'react-router-dom';
import { List } from '@mui/material';
import { FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useAuthService } from '../../hook/useAuthService';
import { useAtom, useAtomValue } from 'jotai';
import { userInfoAtom, searchQueryAtom } from '../../data/atoms/utilsAtoms';
import { UpgradeButton } from '../../atomicComponent/UpgradeButton';
import { getSignupRoute } from '../../constants/featureFlags';

function Header({ HideSideBar }) {
	const [searchKey, setSearchKey] = useAtom(searchQueryAtom);
	const userData = useAtomValue(userInfoAtom);
	const navigate = useNavigate();
	const location = useLocation();

	const [isOpen, setIsOpen] = useState(false);
	const { loggedOutUser } = useAuthService();

	useEffect(() => {
		const urlQuery = new URLSearchParams(location.search).get('search_query') || '';
		if (location.pathname === '/result') {
			setSearchKey(urlQuery);
		} else {
			setSearchKey('');
		}
	}, [location.pathname, location.search, setSearchKey]);

	const handleUsericon = () => {
		navigate('/login');
	};

	const handleUserClick = () => {
		setIsOpen(!isOpen);
	};

	const handleMenuItemAccount = () => {
		setIsOpen(false);
		navigate('/account');
	};

	const handleLogout = () => {
		setIsOpen(false);
		loggedOutUser();
	};

	const handleSearchVideo = () => {
		if (searchKey.length >= 3) {
			navigate(`/result?search_query=${searchKey}`);
		}
	};

	return (
		<div>
			<header className="c-header">
				<div className="row c-header_row">
					{/* Mobile Responsive */}
					<div className="col-md-4 c-mobile_hed-one">
						<div className="c-header_toggbox">
							<div className="c-header_toggle" onClick={HideSideBar}>
								<i className="fa-solid fa-bars"></i>
							</div>
							<div className="c-header_tog-logo">
								<a href="/" aria-label="home">
									<img src={Logo} alt="Logo" />
								</a>
							</div>
						</div>
					</div>

					{/* Search Bar */}
					<div className="col-md-5 c-mobile_hed-two">
						<div>
							<div className="c-header_search">
								<input
									value={searchKey}
									onChange={e => setSearchKey(e.target.value)}
									onKeyDown={e => {
										if (e.key === 'Enter' || e.key === 'Tab') {
											handleSearchVideo();
										}
									}}
									type="text"
									id="search"
									placeholder="Search here"
								/>
								<button
									onClick={handleSearchVideo}
									id="search-button"
									aria-label="search button"
									style={{
										backgroundColor: searchKey ? '#3cb4e4' : '#444448',
										color: searchKey ? 'white' : 'black',

										padding: '0 16px',
										borderRadius: '0px 12px 12px 0px',
										cursor: 'pointer'
									}}
								>
									<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
										<path
											d="M17.8516 17.5L14.2266 13.875M16.1849 9.16667C16.1849 12.8486 13.2001 15.8333 9.51823 15.8333C5.83633 15.8333 2.85156 12.8486 2.85156 9.16667C2.85156 5.48477 5.83633 2.5 9.51823 2.5C13.2001 2.5 16.1849 5.48477 16.1849 9.16667Z"
											stroke="#71717A"
											strokeWidth="1.66667"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</button>
							</div>
						</div>
					</div>

					{/* User Section */}
					<div className="col-md-3 c-mobile_hed-three">
						<div className="c-header_user">
							{userData?.token ? (
								<div className="d-flex flex-column align-items-center">
									<div className="d-flex align-items-center gap-sm-1">
										<UpgradeButton />

										<button
											className="btn profile__btn rounded-circle p-0"
											onClick={handleUserClick}
											style={{ cursor: 'pointer' }}
										>
											<FaUser style={{ fill: '#ffff', cursor: 'pointer' }} fontSize="large" />
										</button>
									</div>

									{isOpen && (
										<List
											className="d-flex flex-column c-header-profile"
											style={{
												background: '#fff',
												position: 'absolute',
												top: '70px'
											}}
										>
											<button className="c-menu_item--button" onClick={handleMenuItemAccount}>
												My account
											</button>
											<button className="c-menu_item--button" onClick={handleLogout}>
												Logout
											</button>
										</List>
									)}
								</div>
							) : (
								<div className="d-flex align-items-center">
									<FaUser
										onClick={handleUsericon}
										style={{ fill: '#ffff', fontSize: 'clamp(1rem, 2vw, 1.8rem)', marginRight: '10px' }}
									/>

									<Link to={getSignupRoute()} className="sign-up-btn">
										SIGN UP
									</Link>
								</div>
							)}
						</div>
					</div>
				</div>
			</header>
		</div>
	);
}

export default Header;
